var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBgBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 542,
    height: 118,
    viewBox: "0 0 542 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.5 33.5C90.7127 61.7983 34 122.165 0.5 166.998C189.833 169.999 563 167.799 541 134.999C513.5 93.9989 441.783 40.5538 407 25.4982C306.5 -18.0031 238.5 1.00032 159.5 33.5Z",
    fill: "url(#paint0_linear_691_354)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_691_354",
    x1: 71.0567,
    y1: -114.572,
    x2: 538.761,
    y2: 173.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBgBottom);
export default __webpack_public_path__ + "static/media/login-bg-bottom.84e147b4fe27863ae2b21b5aaf0da407.svg";
export { ForwardRef as ReactComponent };